import React from "react";

function Header() {
  return (
    <header>
      <h1>NoteVault</h1>
    </header>
  );
}

export default Header;
